<div class="dashboard-content-sec " id="user_edit">
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>

 

    <form (ngSubmit)="saveUser(editForm)" [formGroup]="form" #editForm="ngForm" autocomplete="off"> 

        <div class="row form-section">
            <div class="col">
                <div class="card">
                    <app-breadcrumb *ngIf="!embedded" [crumbList]="crumbList"></app-breadcrumb>

                    <div class="card-title form-row">
                        <div class="col-sm-2">
                            <h5 class="fa fa-user">
                            {{ this.title }}
                            </h5>
                        </div>
                        <div class="col-sm4 mx-auto d-inline-block" *ngIf="!isPersonalProfile">
                            <a (click)="sendEmail()" href="javascrpt:void(0);" class="btn btn-default">{{emailCount}} Welcome Emails Sent</a> 
                        </div>
                        <div class="float-right">
                            <button type="submit" class="btn btn-default align-items-end" tabindex="8">Submit</button>
                        </div>                        
                    </div>

                    <div class="card-form">

                        <div *ngIf="submitted && this.form.invalid" class="invalid-feedback">
                            <span >Please review for the form for invalid fields</span>
                        </div>
    
                        <div *ngIf="this.successful_result"
                            class="alert alert-success" role="alert">
                            Successfully saved record
                        </div>
                        <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                            Unable to save record. Error occurred.
                        </div>
            
                        <div class="form-row">
                            <label class="col-sm-2 control-label">Active</label>
                            <div class="form-group col-sm-4">
                                <label class="switch">
                                    <input type="checkbox" (change)="toggleChange($event)" [checked]="active == 'Yes'" >
                                    <span class="slider"></span>
                                </label>
                                <label class="col-sm-3" id="activeLabel">{{active}}</label> 
                            </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2">First Name</label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="FirstName" 
                                    name="FirstName" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="11" placeholder="">                                    
                            </div>
                            <div class="col-sm-1">
                                &nbsp;
                            </div>
                        </div>

                        <div *ngIf="FirstNameCtrl.invalid && (FirstNameCtrl.dirty || FirstNameCtrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="FirstNameCtrl.errors.required">
                              <span>First Name is required.</span>
                           </div>
                           <div *ngIf="FirstNameCtrl.errors.minlength">
                              First Name must be at least 2 characters long.
                           </div>
                        </div>
       
                        <div class="form-row">
                            <label class='col-sm-2 control-label' for="LastName">Last Name</label>
                            <div class="form-group col-sm-4" >
                                <input formControlName="LastName" type="text" 
                                    class="form-control" tabindex="12" placeholder="">
                            </div>
                        </div>
                        <div *ngIf="LastNameCtrl.invalid && (LastNameCtrl.dirty || LastNameCtrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="LastNameCtrl.errors.required">
                              <span>Last Name is required.</span>
                           </div>
                           <div *ngIf="LastNameCtrl.errors.minlength">
                              Last Name must be at least 2 characters long.
                           </div>
                        </div>

                        <div class="form-row">
                            <label class='col-sm-2' for="EMail">Email</label>
                            <div class="form-group col-sm-4">
                                <input formControlName="EMail" type="text" 
                                        class="form-control" tabindex="13" placeholder="">
                            </div>
                        </div>
                        <div *ngIf="EMailCtrl.invalid && (EMailCtrl.dirty || EMailCtrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="EMailCtrl.errors.required">
                              <span>Email is required.</span>
                           </div>
                           <div *ngIf="EMailCtrl.errors.pattern">
                                <span>Invalid Email format</span>
                           </div>  
                        </div>

                        <div class="form-row">
                            <label class='col-sm-2' for="Password">Password</label>
                            <div class="form-group col-sm-4">
                                <input formControlName="Password" type="password"
                                        class="form-control" tabindex="14" placeholder="">
                            </div>
                        </div>
                        <div *ngIf="PasswordCtrl.invalid && (PasswordCtrl.dirty || PasswordCtrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="PasswordCtrl.errors.required">
                              <span>Password is required.</span>
                           </div>
                           <div *ngIf="PasswordCtrl.errors.pattern">
                                <span>Password must be 8-20 characters and include at least one letter and one number.</span>
                           </div>
                        </div>

                        <div class="form-row" *ngIf="!isPersonalProfile">
                            <label class='col-sm-2' for="SsoProvider">SSO Provider</label>
                            <div class="form-group col-sm-4">
                                <select name="SsoProvider" class="form-control"
                                    formControlName="SsoProvider" tabindex="15">
                                    <option value="">None</option>
                                    <option value="adp">ADP</option>
                                    <option value="gusto">Gusto</option>
                                    <option value="paylocity">Paylocity</option>
                                    <option value="ukg">UKG</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-row" *ngIf="!isPersonalProfile">
                            <label class='col-sm-2' for="SsoSubject">SSO User ID</label>
                            <div class="form-group col-sm-4">
                                <input formControlName="SsoSubject" type="text"
                                        class="form-control" tabindex="15"
                                        placeholder="ADP Associate OID">
                            </div>
                        </div>

                        <div class="form-row" *ngIf="!embedded && !isPersonalProfile">
                            <label class='col-sm-2'>Role</label>
                            <div class='form-group col-sm-4'>
                                <select name="RoleType" class="form-control"
                                    formControlName="RoleType" tabindex="17" (change)="filterRoleProfiles()">
                                    <!-- <option selected value="">Please select Client</option> -->
                                    <option id="{{utype.RoleType}}" value="{{utype.RoleType}}" 
                                            *ngFor="let utype of RoleTypes">{{utype.RoleName}}
                                    </option>

                                </select>

                                <div *ngIf="RoleTypeCtrl.invalid && (RoleTypeCtrl.dirty || RoleTypeCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Role Type is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>

                        <div class="form-row" *ngIf="!embedded && !isPersonalProfile &&
                                                    (form.controls.RoleType.value === '2' || 
                                                     form.controls.RoleType.value === 2)">
                            <label class='col-sm-2'>Client</label>
                            <div class='form-group col-sm-4'>
                                <select name="ID" class="form-control" 
                                   formControlName="ID" tabindex="16" (change)="filterRoleProfiles()">
                                    <option id="{{client.ID}}" value="{{client.ID}}" 
                                            *ngFor="let client of clients">{{client.ClientName}}
                                    </option>

                                </select>

                                <div *ngIf="ClientIDCtrl.invalid && (ClientIDCtrl.dirty || ClientIDCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Client is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>

                        <div class="form-row" *ngIf="(form.controls.RoleType.value === 3 ||
                                                      form.controls.RoleType.value === '3') &&
                                                      !embedded &&
                                                      !isPersonalProfile">
                            <label class='col-sm-2'>Partner</label>
                            <div class='form-group col-sm-4'>
                                <select name="PartnerID" class="form-control" 
                                    formControlName="PartnerID" tabindex="16"  (change)="filterRoleProfiles()">
                                    <!-- <option selected value="">Please select Client</option> -->
                                    <option id="{{partner.ID}}" value="{{partner.ID}}" 
                                            *ngFor="let partner of partners">{{partner.CompanyName}}
                                    </option>

                                </select>

                                <div *ngIf="PartnerIDCtrl.invalid && (PartnerIDCtrl.dirty || PartnerIDCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Partner is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>


                        <div class="form-row" *ngIf="!isPersonalProfile">
                            <label class='col-sm-2'>Role Profile</label>
                            <div class='form-group col-sm-4'>
                                <select name="Role" class="form-control" formControlName="Role" tabindex="17">
                                    <option id="{{role.ID}}" value="{{role.ID}}" 
                                            *ngFor="let role of filteredRoles">{{role.Name}}
                                    </option>

                                </select>

                                <div *ngIf="ClientIDCtrl.invalid && (ClientIDCtrl.dirty || ClientIDCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Role is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
      
